import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WishlistToggleComponentDef } from '@df/session/wishlist/wishlist-toggle.component.def';
import { ActionComponent } from '../../../ui/api/action.component';
@Component({
    selector: 'product-view-wishlist-toggle',
    templateUrl: 'product-view-wishlist-toggle.html',
    styleUrls: ['product-view-wishlist-toggle.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ActionComponent]
})
export class ProductViewWishlistToggleComponent extends WishlistToggleComponentDef {
}
